var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-file"},[_c('div',{staticClass:"download-file-content"},[_c('h2',{staticClass:"download-file-help"},[_vm._v(" 请复制链接至其他浏览器下载文件 ")]),_c('p',{staticClass:"download-file-src"},[_vm._v(" "+_vm._s(_vm.src)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }